
import { Vue, Component, Prop } from "vue-property-decorator";

import AuthCard from "@/components/auth/AuthCard.vue";
import AuthFormLink from "@/components/auth/AuthFormLink.vue";
import UiButton from "@/components/button/ui-button.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import JobBlissLogo from "@/components/icons/jobBlissLogo.vue";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import { CHECK_YOUR_EMAIL } from "@/data/notificationMessagesTexts";

@Component({
  components: {
    AuthCard,
    JobBlissLogo,
    FormGroup,
    AuthFormLink,
    UiButton,
  },
})
export default class ResendSignUp extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isClaim!: boolean;

  loading: boolean = false;

  emailValue: string = "";
  emailSent: boolean = false;

  get title(): string {
    return this.isClaim ? "Claim Your Profile" : "Resend Confirmation Email";
  }

  async submit(): Promise<void> {
    try {
      this.loading = true;
      const uri = `${process.env.VUE_APP_LAMBDA}/resend-cognito-user`;
      const { data } = await this.axios.post(uri, {
        data: { user: { email: this.emailValue } },
      });
      if (!data.success) {
        throw new Error(data.message);
      }

      this.emailSent = true;
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(CHECK_YOUR_EMAIL)
      );
    } catch (e) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
    } finally {
      this.loading = false;
    }
  }
}
